export default function Button({
  label,
  onClick,
  disabled = false,
  largeFont = false,
}) {
  let font = largeFont ? 'text-lg' : 'text-md';

  let className = !disabled
    ? `w-full inline-flex flex-col items-center px-4 py-3 border border-transparent ${font} font-medium
        shadow-sm drop-shadow-lg text-white bg-toyota-gray hover:bg-black disabled:opacity-50 disabled:hover:bg-toyota-gray`
    : `w-full inline-flex flex-col items-center px-4 py-3 border border-transparent ${font} font-medium
        shadow-sm drop-shadow-lg text-white bg-toyota-gray hover:bg-black disabled:opacity-50 disabled:hover:bg-toyota-gray`;

  return (
    <button
      type='button'
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {label}
    </button>
  );
}
